/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router';

import uuid from 'node-uuid';

import {Grid,Row,Col,Form,FormGroup,FormControl,ControlLabel,Button, Table, Glyphicon, Panel} from 'react-bootstrap';
import DealerStore from '../../../stores/DealerStore';
import UserStore from '../../../stores/UserStore';

import UIHelpers from '../../../library/UIHelpers';
import DataHelpers from '../../../library/DataHelpers';
import UserSelect from '../user/userSelect';
import JobSelect from './jobSelect';
import AppConstants from '../../../constants/AppConstants';

class EditDealerView extends React.Component {
    constructor(props) {
        console.log("[EditDealerView] - initialisation");

        super(props);

        this.state = {
            dealerId    : null,
            name        : "",
            address     : "",
            contactname : "",
            phonenumber : "",
            svccontactphone : "",
            contactEmail : "",
            jobs        : [],
            users       : [],
            allUsers    : [],
            addingJobs  : false,
            addingUsers : false,
            dirty       : false
        }

        this.onChangeData = this.onChangeData.bind(this);
        this.saveDealer = this.saveDealer.bind(this);
        this.cancelDealer = this.cancelDealer.bind(this);
        this.actionDeleteJob = this.actionDeleteJob.bind(this) ;
        this.actionAddJob = this.actionAddJob.bind(this);
        this.actionDeleteDealerUser = this.actionDeleteDealerUser.bind(this);

        this.userSelectCancelled = this.userSelectCancelled.bind(this);
        this.userSelected = this.userSelected.bind(this);

        this.jobSelectCancelled = this.jobSelectCancelled.bind(this) ;
        this.jobSelected = this.jobSelected.bind(this);

        this._onDealerChange = this._onDealerChange.bind(this);
    }

    componentDidMount() {
        console.log("[EditDealerView] - componentDidMount");
        DealerStore.addChangeListener(this._onDealerChange) ;
    }

    componentWillUnmount() {
        console.log("[EditDealerView] - componentWillUnmount");
        DealerStore.removeChangeListener(this._onDealerChange) ;
    }

    _onDealerChange(payload) {
        console.log("[EditDealerView] - dealer change event: ", payload);
        if (payload) {
            switch (payload) {
                case "DEALER-JOBS-LOADED":
                    this.setState({jobs: DealerStore.dealerJobs()});
                    break ;

                case "DEALER-JOBS-LOADED-ERROR":
                    UIHelpers.showMessage("A problem occurred loading associated jobs");
                    return ;

                case AppConstants.ALL_DEALER_USERS:
                    this.setState({users: DealerStore.dealerUsers()});

                default: break ;
            }
        }
    }

    componentWillReceiveProps(np) {
        console.log("[EditDealerView] - Will Receive Props -> ", np.mode);
        let s = this.state ;
        s.loading = true ;

        if (!np.dealer) {
            s.dealerId = uuid.v4() ;
            s.name = "" ;
            s.address = "" ;
            s.contactname = "" ;
            s.phonenumber = "" ;
            s.svccontactphone = "" ;
            s.contactEmail = "";
            s.jobs = [];
            s.users = [];
        }
        else {
            s.dealerId = np.dealer.dealerId ;
            s.name = np.dealer.name ;
            s.address = np.dealer.address ;
            s.contactname = np.dealer.contactName ;
            s.phonenumber = np.dealer.contactPhone ;
            s.contactEmail = np.dealer.contactEmail;
            s.svccontactphone = np.dealer.svcContactPhone ;
            s.jobs = DealerStore.dealerJobs() ;
            s.users = DealerStore.dealerUsers();
        }

        s.removedJobs = [];
        s.removedUsers = [];
        s.dirty = false ;
        s.allUsers = UserStore.users();
        this.setState(s);
    }

    onChangeData(e) {
        e.preventDefault() ;
        console.log("ON CHANGE");

        let nm = ReactDOM.findDOMNode(this.refs.name).value;
        let ad = ReactDOM.findDOMNode(this.refs.address).value;
        let cn = ReactDOM.findDOMNode(this.refs.contactname).value;
        let ph = ReactDOM.findDOMNode(this.refs.phonenumber).value;
        let sp = ReactDOM.findDOMNode(this.refs.svccontactphone).value;
        let em = ReactDOM.findDOMNode(this.refs.contactEmail).value;
        let s = this.state ;
        s.name = nm ;
        s.address = ad ;
        s.phonenumber = ph ;
        s.contactname = cn ;
        s.svccontactphone = sp ;
        s.contactEmail = em ;
        s.dirty = true ;
        this.setState(s);
    }

    saveDealer() {
        console.log("SAVE DEALER");
        let dealer = {
            "dealerId" : this.state.dealerId,
            "name" : DataHelpers.undefinedFromEmptyString(this.state.name),
            "contactName" : DataHelpers.undefinedFromEmptyString(this.state.contactname),
            "contactPhone" : DataHelpers.undefinedFromEmptyString(this.state.phonenumber) ,
            "svcContactPhone" : DataHelpers.undefinedFromEmptyString(this.state.svccontactphone) ,
            "contactEmail" : DataHelpers.undefinedFromEmptyString(this.state.contactEmail) ,
            "address" : DataHelpers.undefinedFromEmptyString(this.state.address),
            "jobs" : this.state.jobs.map((j) => j.jobId),
            "users" : this.state.users.map((u) => u.userId),
            "deletedJobs" : Object.keys(this.state.removedJobs),
            "deletedUsers" : Object.keys(this.state.removedUsers)
        }
        this.props.closeHandler({cancelled: false, dealer : dealer});
    }

    cancelDealer() {
        this.props.closeHandler({cancelled: true});
    }

    actionDeleteJob(job) {
        if (!UIHelpers.confirmAction("Are you sure you want to remove this job from this dealer?")) {
            return ;
        }

        console.log("[JOB] - delete job: " + JSON.stringify(job));
        let s = this.state ;
        for (let ix = 0 ; ix < s.jobs.length; ix++) {
            let j = s.jobs[ix] ;
            if (j.jobId === job.jobId) {
                s.jobs.splice(ix,1) ;
                s.removedJobs[job.jobId] = true ;
                s.dirty = true ;
                break ;
            }
        }

        this.setState(s);
    }

    actionDeleteDealerUser(user) {
        console.log("[DEALER] - delete attached user: " , user);
        if (!user) {
            return ;
        }

        if (!UIHelpers.confirmAction("Are you sure you want to remove this user from this dealer?")) {
            return ;
        }

        // user.dealerId = undefined ; // Cannot set to null as DynamoDB objects!
        // userAPI.saveUser(user, ActionResult.make("USER_DEALER_REMOVE",this.onActionComplete));
        let s = this.state ;
        for (let ix = 0 ; ix < s.users.length; ix++) {
            let j = s.users[ix] ;
            if (j.userId === user.userId) {
                s.users.splice(ix,1) ;
                s.removedUsers[user.userId] = true ;
                s.dirty = true ;
                break ;
            }
        }

        this.setState(s);
    }

    actionAddJob() {
        let s = this.state ;
        s.addingJobs = !s.addingJobs;
        this.setState(s);
    }

    actionAddUser() {
        this.setState({addingUsers : true});
    }

    userSelectCancelled() {
        this.setState({addingUsers : false});
    }

    userSelected(u) {
        console.log("SELECTED USERS: ", u) ;
        // TODO - fill in this bit
        if (u === null || u.length === 0) {
            this.setState({addingUsers : false});
            return ;
        }

        let s = this.state ;
        console.log("USERS=", s.users);
        for (let ui in u) {
            let user = u[ui];

            let existing = s.users.find((v) => {
                console.log("FIND USER=", v) ;
                return v.userId === user.userId
            }) ;
            if (!existing) {
                s.dirty = true ;
                s.users.push(user);
            }
        }

        s.addingUsers = false ;
        this.setState(s);
    }

    jobSelectCancelled() {
        this.setState({addingJobs : false});
    }

    jobSelected(j) {
        if (j === null || j.length === 0) {
            this.setState({addingJobs : false});
            return ;
        }

        let s = this.state ;
        for (let ji in j) {
            let job = j[ji];

            let existing = s.jobs.find((v) => {
                console.log("FIND JOB=", v) ;
                return v.jobId === job.jobId
            }) ;
            if (!existing) {
                s.dirty = true ;
                s.jobs.push(job);
            }
        }

        s.addingJobs = false ;
        this.setState(s);
    }

    render() {
        let self = this ;

        let header = (<div>
                <b>Manage Dealer</b>
                <div className="pull-right">
                    <Button type="button" bsSize="small" bsStyle="danger" onClick={this.cancelDealer}><Glyphicon glyph="remove"/>{' '}Cancel</Button>{' '}
                    <Button type="button" bsSize="small" bsStyle="success" disabled={!this.state.dirty} onClick={this.saveDealer}><Glyphicon glyph="save"/>{' '}Save</Button>
                </div>
            </div>);

        let hs = this.state.dirty ? "danger" : "success";
        return (

                <Panel header={header}  bsStyle={hs}>
                    {this.state.addingUsers &&
                        <UserSelect users={this.state.allUsers} onSelectCancelled={this.userSelectCancelled} onSelect={this.userSelected} />
                    }
                    {this.state.addingJobs &&
                        <JobSelect  onSelectCancelled={this.jobSelectCancelled} onSelect={this.jobSelected} selectedJobs={this.state.jobs} />
                    }
                    <Grid>
                        <Row>
                            <Col>
                                <Form horizontal onSubmit={event => event.preventDefault()}>
                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} md={3}>Name</Col>
                                        <Col md={7}>
                                            <FormControl onChange={this.onChangeData} type="text" placeholder="dealer name" ref="name" value={this.state.name}/>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup controlId="formHorizontalPassword">
                                        <Col componentClass={ControlLabel} md={3}>Address</Col>
                                        <Col md={7}>
                                            <FormControl onChange={this.onChangeData} type="text" placeholder="address" ref="address" value={this.state.address}/>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} md={3}>Contact Name</Col>
                                        <Col md={7}>
                                            <FormControl onChange={this.onChangeData} type="text" placeholder="main contact name" ref="contactname" value={this.state.contactname}/>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} md={3}>Contact Phone Number</Col>
                                        <Col md={7}>
                                            <FormControl onChange={this.onChangeData} type="text" placeholder="contact phone number" ref="phonenumber" value={this.state.phonenumber}/>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} md={3}>Service Manager Phone Number</Col>
                                        <Col md={7}>
                                            <FormControl onChange={this.onChangeData} type="text" placeholder="service contact phone number" ref="svccontactphone" value={this.state.svccontactphone}/>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup controlId="formHorizontalEmail">
                                        <Col componentClass={ControlLabel} md={3}>Contact Email</Col>
                                        <Col md={7}>
                                            <FormControl onChange={this.onChangeData} type="text" placeholder="email" ref="contactEmail" value={this.state.contactEmail}/>
                                        </Col>
                                    </FormGroup>
                                </Form>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form horizontal onSubmit={event => event.preventDefault()}>
                                <FormGroup controlId="fmJobs">
                                    <Col componentClass={ControlLabel} md={3}>Assigned Jobs</Col>
                                    <Col  md={7}>
                                        <Table striped bordered hover>
                                            <thead>
                                            <tr><th>Name</th><th>Client</th><th><Button className="pull-right" bsStyle="success" bsSize="xsmall" onClick={self.actionAddJob.bind(self)}><Glyphicon glyph="plus"/></Button></th></tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.jobs.map((j) => {
                                                        return (
                                                            <tr key={j.jobId}>
                                                                <td>{j.displayName}</td>
                                                                <td>{j.client}</td>
                                                                <td  className="pull-right">
                                                                    <Button bsStyle="danger" bsSize="xsmall" onClick={self.actionDeleteJob.bind(self,j)}><Glyphicon glyph="trash"/></Button>{'  '}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </FormGroup>

                            </Form>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form horizontal onSubmit={event => event.preventDefault()}>
                                <FormGroup controlId="fmJobs">
                                    <Col componentClass={ControlLabel} md={3}>Current Users</Col>
                                    <Col  md={7}>
                                        <Table striped bordered hover>
                                            <thead>
                                            <tr><th>Name</th><th><Button className="pull-right" bsStyle="success" bsSize="xsmall" onClick={self.actionAddUser.bind(self)}><Glyphicon glyph="plus"/></Button></th></tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.users.map((u) => {
                                                        return (
                                                            <tr key={u.userId}>
                                                                <td>{u.name}</td>
                                                                <td  className="pull-right">
                                                                    <Button bsStyle="danger" bsSize="xsmall" onClick={self.actionDeleteDealerUser.bind(self,u)}><Glyphicon glyph="trash"/></Button>{'  '}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </FormGroup>

                            </Form>
                        </Col>
                    </Row>


                </Grid>
            </Panel>

        );
    }
}

export default withRouter(EditDealerView);




// WEBPACK FOOTER //
// ./src/app/components/admin/dealers/editDealerView.react.js